import { setLocale } from "yup";

export default {
  install: () => {
    // Documentation: https://github.com/jquense/yup?tab=readme-ov-file#error-message-customization
    setLocale({
      mixed: {
        required: ({ path }) => `${path} is required`
      },
      string: {
        email: "Enter a valid email address in full email@domain.com format."
      }
    });
  }
};
